import { useState } from "react";
import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { DateFormScreen } from "../inputs/DateFormScreen";

import dayjs from "dayjs";
import { mediosPago } from "../../../data";





export const BusquedaFechaTerminoMedio = ({ inicio, final, termino, chageInicio, chageFinal, chageTermino, titulo="Buscar", 
    place="Buscar.", mT=0, medio, chageMedioPago }) => {
  

    const [formValues, setFormValues] = useState({
        start: inicio ? dayjs(inicio) : null,
        end: final ? dayjs(final) : null,
        termino: termino || "",
        medio: medio || '',
    });
    const { start, end } = formValues;



    const handleChangeStart = (newValue) => {
        setFormValues((prev) => ({ ...prev, start: newValue }));
    };

    
    const handleChangeEnd = (newValue) => {
        setFormValues((prev) => ({ ...prev, end: newValue }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };



    const handleBuscarInfo = (e) => {
        e.preventDefault();
        const fechaInicio = dayjs(start).isValid() ? dayjs(start).startOf("day") : "";
        const fechaFinal = dayjs(end).isValid() ? dayjs(end).endOf("day") : "";
        chageInicio(fechaInicio);
        chageFinal(fechaFinal);
        chageTermino(formValues.termino);
        chageMedioPago(formValues.medio);
    };



    return (
        <form style={{ width: "100%" }} onSubmit={handleBuscarInfo}>
            <Grid container direction="row" alignItems="center" spacing={2} mt={mT} mb={3}>
                <Grid item xs={12} sm={3}>
                    <TextField
                      autoComplete="off"
                      label={titulo}
                      placeholder={place}
                      fullWidth
                      color="secondary"
                      name="termino"
                      value={formValues.termino}
                      onChange={handleInputChange}
                      size="small"
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField
                        select
                        label="Busqueda medio"
                        fullWidth
                        name="medio"
                        value={ formValues.medio }
                        onChange={ handleInputChange }  
                        size="small"
                    >    
                        <MenuItem value=''>Seleccione Medio de Pago</MenuItem>
                        {mediosPago.map( item => (
                            <MenuItem key={item} value={item}> {item}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <DateFormScreen
                        label="Fecha Inicial"
                        value={start}
                        onChange={handleChangeStart}
                        permitirPasado={true}
                    />
                </Grid>

                <Grid item xs={12} sm={3}>
                    <DateFormScreen
                        label="Fecha Final"
                        value={end}
                        minDate={start}
                        onChange={handleChangeEnd}
                        permitirPasado={true}
                    />
                </Grid>

                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                  <Grid item xs={12} sm={4}>
                    <Button variant="contained" fullWidth color="primary" type="submit">Filtrar</Button>
                  </Grid>
                </Grid>
            </Grid>
        </form>
    );
};
